import BlurredExcessImage from './BlurredExcessImage';

export default BlurredExcessImage;
